import React from 'react';

interface BannerContentProps {
  layout: 'centered' | 'default';
  emoji?: string;
  emojiAnimation?: 'bounce' | 'pulse' | 'none';
  title: string;
  description: string;
  titleColor?: string;
  descriptionColor?: string;
  children?: React.ReactNode;
}

export const BannerContent: React.FC<BannerContentProps> = ({
  layout = 'default',
  emoji,
  emojiAnimation = 'none',
  title,
  description,
  titleColor = '',
  descriptionColor = '',
  children
}) => {
  const getLayoutClasses = () => {
    return layout === 'centered' 
      ? 'text-center space-y-6' 
      : 'space-y-6';
  };

  const getEmojiAnimationClass = () => {
    switch (emojiAnimation) {
      case 'bounce':
        return 'animate-bounce';
      case 'pulse':
        return 'animate-pulse';
      default:
        return '';
    }
  };

  const getTitleClasses = () => {
    const baseClasses = 'text-3xl font-bold';
    return titleColor ? `${baseClasses} ${titleColor}` : `${baseClasses}`;
  };

  const getDescriptionClasses = () => {
    const baseClasses = 'text-lg max-w-md leading-relaxed';
    const layoutClasses = layout === 'centered' ? 'mx-auto' : '';
    return descriptionColor 
      ? `${baseClasses} ${layoutClasses} ${descriptionColor}` 
      : `${baseClasses} ${layoutClasses}`;
  };

  return (
    <div className={getLayoutClasses()}>
      {/* Emoji */}
      {emoji && (
        <div className="flex items-center justify-center">
          <span className={`text-6xl ${getEmojiAnimationClass()}`}>
            {emoji}
          </span>
        </div>
      )}

      {/* Title and Description */}
      <div className="space-y-2">
        <h2 className={getTitleClasses()}>
          {title}
        </h2>
        <p className={getDescriptionClasses()}>
          {description}
        </p>
      </div>

      {/* Additional content */}
      {children}
    </div>
  );
};